import React, { useState, useCallback } from "react";
import { motion } from "framer-motion";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import { useMediaQuery } from "@mui/material"; // ✅ import from MUI

const AILineLoader = () => {
  const [waveActive, setWaveActive] = useState(false);
  const handleBallAnimationEnd = useCallback(() => {
    setWaveActive(true);
  }, []);
  const isMobile = useMediaQuery("(max-width:600px)");
  const text = isMobile
    ? "AI  Is  Creating  Job..."
    : "Preparing  Your  AI  Powered  Job  Post...";

  const loaderWidth = isMobile ? 260 : 480;
  const iconSize = 28;

  const gradient =
    "linear-gradient(90deg, #8a3ffc 0%, #c43af3 50%, #ff2e74 100%)";
  return (
    <div
      style={{
        height: "100px",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "Inter, sans-serif",
      }}
    >
      <style>
        {`
          @keyframes pulseGlow {
            0%, 100% { transform: scale(1); opacity: 0.9; }
            50% { transform: scale(1.15); opacity: 1; }
          }
        `}
      </style>

      <div
        style={{
          textAlign: "center",
          position: "relative",
          display: "inline-block",
          width: `${loaderWidth}px`,
        }}
      >
        <div
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            marginBottom: "2px",
            height: "30px",
          }}
        >
          <motion.div
            initial={{ x: 0, rotate: 0 }}
            animate={{
              x: `calc(${loaderWidth}px - ${iconSize}px)`, 
              rotate: 360 * 3,
            }}
            transition={{
              duration: 3,
              ease: [0.7, 0.2, 0.3, 1],
            }}
            style={{
              position: "absolute",
              left: -7,
              bottom: 3,
              zIndex: 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: gradient,
              borderRadius: "50%",
              padding: "4px",
              filter:
                "drop-shadow(0 0 8px rgba(136,58,255,0.7)) drop-shadow(0 0 12px rgba(255,46,116,0.5))",
            }}
          >
            <TipsAndUpdatesIcon
              sx={{
                fontSize: 26,
                color: "#fff",
                animation: "pulseGlow 1.5s ease-in-out infinite",
              }}
            />
          </motion.div>
          <motion.h2
            style={{
              overflow: "hidden",
              whiteSpace: "nowrap",
              fontFamily: "Inter, sans-serif",
              fontWeight: 600,

              fontSize: "1.2rem",
              display: "flex",
              gap: "2px",
            }}
            initial={{ width: 0 }}
            animate={{ width: "100%" }}
            transition={{
              duration: 3.5,
              ease: "easeInOut",
            }}
            onAnimationComplete={handleBallAnimationEnd}
          >
            {text.split("").map((letter, index) => (
              <motion.span
                key={index}
                initial={ 
                    waveActive ? 
                    { opacity: 1, scale: 1, y: 0 } : {}
                }
                animate={
                  waveActive
                    ? {
                        opacity: [1, 1, 1, 1],
                        scale: [1, 1.05, 1.1, 1.05, 1],
                        y: [0, -1, -2, -3, -2,-1.5, 0], 
                      }
                    : {}
                }
                transition={
                  waveActive
                    ? {
                        repeat: Infinity,
                        duration: 2.5,
                        delay: index * 0.06,
                        ease: "easeInOut",
                      }
                    : {}
                }
                style={{
                  display: "inline-block",
                  background: gradient,
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                {letter}
              </motion.span>
            ))}
          </motion.h2>
        </div>

        <div
          style={{
            width: "100%",
            height: "3px",
            background: "rgba(255,255,255,0.15)",
            borderRadius: "10px",
            overflow: "hidden",
            position: "relative",
          }}
        >
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: "100%" }}
            transition={{
              duration: 3,
              ease: [0.7, 0.2, 0.3, 1],
            }}
            style={{
              height: "100%",
              background: gradient,
              borderRadius: "10px",
              position: "absolute",
              top: 0,
              left: 0,
              boxShadow:
                "0 0 8px rgba(136,58,255,0.7), 0 0 12px rgba(255,46,116,0.5)",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AILineLoader;
